import script from "./LcabMenuDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./LcabMenuDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./LcabMenuDropdown.vue?vue&type=style&index=0&id=1f75129e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f75129e"]])

export default __exports__